import React from 'react';
export const evaluationCheckListItems = (data) => {
  return [
    {
      label: 'agent-introduced-themselves',
      passed: data?.agentPerformanceDetails?.agentName?.isSuccessful,
      achieved: data?.agentPerformanceDetails?.agentName?.value,
      base: data?.agentPerformanceDetails?.agentName?.percentage,
      criteria: 'agent-name',
    },
    {
      label: 'company-name-mentioned',
      passed: data?.agentPerformanceDetails?.companyName?.isSuccessful,
      achieved: data?.agentPerformanceDetails?.companyName?.value,
      base: data?.agentPerformanceDetails?.companyName?.percentage,
      criteria: 'company-name',
    },
    {
      label: 'reason-for-call-explained',
      criteria: 'reason-for-calling',
      passed: data?.agentPerformanceDetails?.reasonForCalling?.isSuccessful,
      achieved: data?.agentPerformanceDetails?.reasonForCalling?.value,
      base: data?.agentPerformanceDetails?.reasonForCalling?.percentage,
    },
    {
      label: 'consent-to-continue',
      criteria: 'consent-to-continue-the-call',
      passed:
        data?.agentPerformanceDetails?.consentToContinueTheCall?.isSuccessful,
      achieved: data?.agentPerformanceDetails?.consentToContinueTheCall?.value,
      base: data?.agentPerformanceDetails?.consentToContinueTheCall?.percentage,
    },
    {
      label: 'crm-update',
      criteria: 'crm-update',
      passed: data?.agentPerformanceDetails?.crmUpdate?.isSuccessful,
      achieved: data?.agentPerformanceDetails?.crmUpdate?.value,
      base: data?.agentPerformanceDetails?.crmUpdate?.percentage,
    },
    {
      label: 'usps-mentioned',
      criteria: 'us-ps',
      passed: data?.agentPerformanceDetails?.usPs?.isSuccessful,
      achieved: data?.agentPerformanceDetails?.usPs?.value,
      base: data?.agentPerformanceDetails?.usPs?.percentage,
    },
    {
      label: 'market-knowledge-demonstrated',
      criteria: 'market-knowledge',
      passed: data?.agentPerformanceDetails?.marketKnowledge?.isSuccessful,
      achieved: data?.agentPerformanceDetails?.marketKnowledge?.value,
      base: data?.agentPerformanceDetails?.marketKnowledge?.percentage,
    },
    {
      label: 'follow-up-consent',
      criteria: 'follow-up-consent',
      passed: data?.agentPerformanceDetails?.followUpConsent?.isSuccessful,
      achieved: data?.agentPerformanceDetails?.followUpConsent?.value,
      base: data?.agentPerformanceDetails?.followUpConsent?.percentage,
    },
    {
      label: 'important-questions-asked',
      criteria: 'probing-questions',
      passed: data?.agentPerformanceDetails?.probingQuestions?.isSuccessful,
      achieved: data?.agentPerformanceDetails?.probingQuestions?.value,
      base: data?.agentPerformanceDetails?.probingQuestions?.percentage,
    },
    {
      label: 'objections-handled',
      criteria: 'objections-call-handling',
      passed:
        data?.agentPerformanceDetails?.objectionsCallHandling?.isSuccessful,
      achieved: data?.agentPerformanceDetails?.objectionsCallHandling?.value,
      base: data?.agentPerformanceDetails?.objectionsCallHandling?.percentage,
    },
    {
      label: 'clear-sales-pitch',
      criteria: 'sales-pitch',
      passed: data?.agentPerformanceDetails?.salesPitch?.isSuccessful,
      achieved: data?.agentPerformanceDetails?.salesPitch?.value,
      base: data?.agentPerformanceDetails?.salesPitch?.percentage,
    },
    {
      label: 'professional-tone',
      criteria: 'tone-of-voice',
      passed: data?.agentPerformanceDetails?.toneOfVoice?.isSuccessful,
      achieved: data?.agentPerformanceDetails?.toneOfVoice?.value,
      base: data?.agentPerformanceDetails?.toneOfVoice?.percentage,
    },
  ];
};

export const insightsItems = (data) => {
  return [
    {
      emoji: '💬',
      title: 'sentiment-analysis',
      text: data?.sentimentAnalysis,
    },
    {
      emoji: '🧠',
      title: 'reason-for-agent-evaluation',
      text: data?.agentEvaluations[0]?.evaluations[0]?.reason,
    },
    {
      emoji: '📢',
      title: 'advice-for-agent',
      text: data?.adviceForAgent,
    },
    {
      emoji: '📞',
      title: 'call-assessment',
      text: data?.callAssessment,
    },
    {
      emoji: '📈',
      title: 'lead-assessment',
      text: data?.leadAssessment,
    },
    {
      emoji: '📝',
      title: 'additional-notes',
      text: data?.additionalNotes,
    },
  ];
};

export const getEvaluationStyles = (item, isNotEvaluable) => {
  const isCrmUpdate = item.criteria === 'crm-update';
  const isAchievedNull = item.achieved === null;

  const containerClass = isCrmUpdate
    ? isAchievedNull
      ? 'bg-light-disabled'
      : item.passed
      ? 'bg-light-success'
      : 'bg-light-danger'
    : isNotEvaluable
    ? 'bg-light-disabled'
    : item.passed
    ? 'bg-light-success'
    : 'bg-light-danger';

  const iconWrapperClass = isCrmUpdate
    ? isAchievedNull
      ? 'disabled-dash'
      : item.passed
      ? 'icon-success'
      : 'icon-danger'
    : isNotEvaluable
    ? 'disabled-dash'
    : item.passed
    ? 'icon-success'
    : 'icon-danger';

  const icon =
    (isCrmUpdate && isAchievedNull) || (!isCrmUpdate && isNotEvaluable) ? (
      '—'
    ) : (
      <span
        className={`mdi ${
          item.passed ? 'mdi-checkbox-marked' : 'mdi-window-close'
        }`}
      ></span>
    );

  return {
    containerClass,
    iconWrapperClass,
    icon,
  };
};
